import React, { Component } from 'react';
import { Table, Input, Button, Icon } from 'antd';

import styles from './ProductTable.module.css';
import expandedRow from './ProductTableExtended';
import './ProductTable.css';

class ProductTable extends Component {
  state = {
    filterDropdownVisible: false,
    data: null,
    searchText: '',
    filtered: false,
  };

  onInputChange = e => {
    this.setState({ searchText: e.target.value });
  };

  onSearch = () => {
    const { searchText } = this.state;
    const reg = new RegExp(searchText, 'gi');
    this.setState({
      filterDropdownVisible: false,
      filtered: !!searchText,
      data: this.props.products
        .map(record => {
          const match = record.title.match(reg);
          if (!match) {
            return null;
          }
          return {
            ...record,
            title: (
              <span>
                {record.title.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map(
                  (text, i) =>
                    text.toLowerCase() === searchText.toLowerCase() ? (
                      <span key={i} className="highlight">
                        {text}
                      </span>
                    ) : (
                      text
                    ), // eslint-disable-line
                )}
              </span>
            ),
          };
        })
        .filter(record => !!record),
    });
  };

  renderNoData = data => {
    if (data.length === 0) return <span style={{ color: 'lightgrey' }}>No data</span>;
    else return data;
  };

  renderPrice = (column, row) => {
    return `${column} ${row['price_unit']}`;
  };

  renderSalePrice = (column, row) => {
    if (column === 0 || column === '') {
      return '';
    }
    return `${column} ${row['price_unit']}`;
  };

  render() {
    const columns = [
      {
        title: 'Title',
        dataIndex: 'title',
        key: 'title',
        filterDropdown: (
          <div className={styles.FilterDropdown}>
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Search title"
              value={this.state.searchText}
              onChange={this.onInputChange}
              onPressEnter={this.onSearch}
            />
            <Button type="primary" onClick={this.onSearch}>
              Search
            </Button>
          </div>
        ),
        filterIcon: <Icon type="search" style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }} />,
        filterDropdownVisible: this.state.filterDropdownVisible,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              filterDropdownVisible: visible,
            },
            () => this.searchInput && this.searchInput.focus(),
          );
        },
      },
      {
        title: 'Product Information',
        children: [
          {
            title: 'Brand',
            dataIndex: 'brand_title',
            key: 'brand_title',
            width: '14%',
            render: row => this.renderNoData(row),
          },
          {
            title: 'Country',
            dataIndex: 'country',
            key: 'country',
            width: '14%',
            render: row => this.renderNoData(row),
          },
          {
            title: 'Sub Type',
            dataIndex: 'sub_type',
            key: 'sub_type',
            width: '14%',
            render: row => this.renderNoData(row),
          },
        ],
      },
      {
        title: 'Price',
        dataIndex: 'price_format',
        key: 'price_format',
        width: 80,
        render: (row, row1) => this.renderPrice(row, row1),
      },
      {
        title: 'Sales price',
        dataIndex: 'price_sale_format',
        key: 'price_sale_format',
        width: 80,
        render: (row, row1) => this.renderSalePrice(row, row1),
      },
      {
        title: 'Image',
        key: 'image_url',
        width: 90,
        render: row => <img width="50" height="50" src={row.image_url} alt="" />,
      },
    ];
    const { updateCartHandler, selectedRowKeys } = this.props;
    const rowSelection = {
      selectedRowKeys,
      onChange: selectedRowKeys => {
        updateCartHandler(selectedRowKeys);
      },
    };
    const { isLoading } = this.props;
    return (
      <Table
        loading={isLoading}
        className={[styles.Table, 'nested-table'].join(' ')}
        bordered
        filtered={this.state.filtered}
        expandedRowRender={row => expandedRow(row)}
        rowKey={record => record.id}
        columns={columns}
        dataSource={!this.state.data ? this.props.products : this.state.data}
        rowSelection={rowSelection}
      />
    );
  }
}

export default ProductTable;



// WEBPACK FOOTER //
// ./src/components/Product/ProductTable/ProductTable.js